import widgetModes from 'Constants/widget-modes';

export default {
    TABLE: widgetModes.TABLE,
    PIE_CHART: widgetModes.CHART,
    BAR_CHART: 'barChart'
};
